import { render } from "./q3.vue?vue&type=template&id=40c59f98&scoped=true"
import script from "./q3.vue?vue&type=script&lang=js"
export * from "./q3.vue?vue&type=script&lang=js"

import "./q3.vue?vue&type=style&index=0&id=40c59f98&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c59f98"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40c59f98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40c59f98', __exports__)) {
    api.reload('40c59f98', __exports__)
  }
  
  module.hot.accept("./q3.vue?vue&type=template&id=40c59f98&scoped=true", () => {
    api.rerender('40c59f98', render)
  })

}


export default __exports__